import { render, staticRenderFns } from "./NoticeDialog.vue?vue&type=template&id=3bc908b2&scoped=true&"
import script from "./NoticeDialog.vue?vue&type=script&lang=ts&"
export * from "./NoticeDialog.vue?vue&type=script&lang=ts&"
import style0 from "./NoticeDialog.vue?vue&type=style&index=0&id=3bc908b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc908b2",
  null
  
)

export default component.exports